module.exports = __webpack_public_path__ + "img/logochita.cc1027e5.png";